import types, { ActionCreators } from './types';

const requestSegmentOK: ActionCreators['RequestSegmentOK'] = (segment) => ({
  type: types.REQUEST_SEGMENT_OK,
  segment,
});

const actions = {
  requestSegmentOK,
};

export default actions;
